export function getAssistantAdvanceLabel(
  isLastStep: boolean,
  isScenario: boolean
): string {
  if (!isLastStep) return "Next";

  if (isScenario) return "Complete scenario";

  return "Finish";
}
